// extracted by mini-css-extract-plugin
export default {"footer-link":"footer-link__uOSEj","icon":"icon__LvPtK","spinner":"spinner__GBy81"};